import { GET_PERMISSIONS } from "../../constants/apis";
import {PERMISSIONS} from "../../constants/actionTypes";

export const permissions =
  () =>
  (dispatch, getState, { apiReport }) =>
    apiReport
      .get(GET_PERMISSIONS)
      .then((result) => {
        dispatch({
          type: PERMISSIONS,
          payload: {
            ...result,
          },
        });
      })
      .catch((error) => {
        throw error;
      });